export default __webpack_public_path__ + "img/selects-07c4830d.png";